import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import CertificationEdit from '@/ui/pages/CertificationEdit/CertificationEdit';

export const Route = createFileRoute('/_dashboard/certifications/$id/edit')({
  beforeLoad: requireRoute('/certifications/$id/edit'),
  component: CertificationEdit,
});
